exports = module.exports = require("../../../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#solutionDescriptions {\n  height: calc(100% - 0%); }\n  #solutionDescriptions mat-card {\n    border-radius: 20px;\n    padding: 10px;\n    height: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/left/operations/solution-description/create-solution-description/create-solution-description.component.scss
// module id = ../../../../../src/app/main/content/apps/e-commerce/orders/sidenavs/left/operations/solution-description/create-solution-description/create-solution-description.component.scss
// module chunks = main